window.Fastweb = {};
Fastweb.Widgets = {};
